import React, { Component } from 'react';
import { StyleSheet, View, Text } from 'react-native';

class Chapter1 extends Component {
    render() {
        return (
            <View style={styles.container}>
                <Text style={[styles.heading]}>
                    {
                        "Introduction"
                    }
                </Text>
                <Text style={styles.text}>
                    {
                        "M18 is opened to integration with different third party systems. " +
                        "RESTful Web Services are provided in M18 for developers to accomplish different tasks."
                    }
                </Text>
                <Text style={styles.text}>
                    {
                        "This tutorial focuses on"
                    }
                </Text>
                <Text style={[styles.text, { paddingLeft: 20 }]}>
                    {
                        "1.	Create/Update/Delete Module Data"
                    }
                </Text>
                <Text style={[styles.text, { paddingLeft: 20 }]}>
                    {
                        "2.	Generate Module Data Report"
                    }
                </Text>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        width: 700,
    },
    heading: {
        paddingTop: 20,
        fontSize: 30,
        fontWeight: 'bold',
    },
    text: {
        paddingTop: 20,
    },
});

export default Chapter1;



// WEBPACK FOOTER //
// ./src/pages/ch1/Chapter1.js